import { render } from "./DrawingGM.vue?vue&type=template&id=4900d48e&scoped=true"
import script from "./DrawingGM.vue?vue&type=script&lang=js"
export * from "./DrawingGM.vue?vue&type=script&lang=js"

import "./DrawingGM.vue?vue&type=style&index=0&id=4900d48e&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4900d48e"]])

export default __exports__